import { render, staticRenderFns } from "./u-select-solo-rounded.vue?vue&type=template&id=06f8ecf4&scoped=true"
import script from "./u-select-solo-rounded.vue?vue&type=script&lang=js"
export * from "./u-select-solo-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8ecf4",
  null
  
)

export default component.exports